"use strict";
import React from "react";
import _ from "underscore";
function noAuditFlagsMessage() {
  return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Audit Flags Set");
}
function showAuditFlag(auditFlag) {
  if (auditFlag.customMessage) {
    return /* @__PURE__ */ React.createElement("li", null, auditFlag.label, ": ", auditFlag.customMessage);
  } else {
    return /* @__PURE__ */ React.createElement("li", null, auditFlag.label);
  }
}
function hasAuditFlags(props) {
  return !_.isEmpty(props.flags);
}
function showAuditFlags(props) {
  return /* @__PURE__ */ React.createElement("ul", { className: "factor-invoice--audit-flags" }, _.map(props.flags, showAuditFlag));
}
export default function AuditFlagDisplay(props) {
  return /* @__PURE__ */ React.createElement("div", null, hasAuditFlags(props) ? showAuditFlags(props) : noAuditFlagsMessage());
}
